export default {
  userDetails(state) {
    return state.user;
  }
};
